import qs from "qs";
import request from "@/utils/request";
import requestSC from "@/utils/requestSC";
import requestApi from "@/utils/requestApi";

// 用户信息
export async function getUser() {
  return request.get("nxin.usercenter.user.get/1.0");
}

// 获取用户身份
export async function getUserEnt() {
  return request.get("nxin.usercenter.enterprise.get/2.0");
}

// 请求是否弹窗的接口
export async function queryGuideShow(params) {
  return request.post("nxin.usercenter.guide.need.show/2.0", qs.stringify(params));
}

// 关闭弹窗的接口--记录次数
export async function queryGuiderecord(params) {
  return request.post("nxin.usercenter.guide.record/1.0", qs.stringify(params));
}

// 获取地区
export async function getAreas(params) {
  return requestApi.post("/scbasic/system/area/childAreasList", params);
}

// 地址信息
export async function getDeliveryList() {
  return requestSC.post("/mob/member/delivery/toList");
}

// 默认地址详情
export async function getDefaultDelivery() {
  return requestSC.get("/mob/member/delivery/getDefaultDelivery");
}

// 支付-跳转小程序失败后的处理
export async function getAppIdCache(uuid) {
  return requestSC.get(`/nos/xcxMember/getAppIdCache/${uuid}`);
}

// 查询当前登录用户是否是vip
export async function selMemberVip() {
  return requestSC.get("/rest/member/selMemberVip");
}

// 获取商品评价列表
export async function getGoodsEvaluateList(params) {
  return requestApi.post("/sctrading/evaluate/selGoodsEvaluateList", params);
}

// 获取商品评价概况
export async function getGoodsEvaluateCollect(params) {
  console.log("paramsparamsparamsparams");
  return requestApi.post("/sctrading/evaluate/selGoodsEvaluateCollect", params);
}

// 获取商品套餐列表
export async function getPackageSkuList(params) {
  return requestApi.post("/sctrading/goods/goodspackage/selList", params);
}

// 获取是否跳转爆品页
export async function selBp(params) {
  return requestApi.post("/sctrading/goods/selBp", params);
}
// 查询爆品skuId集合
export async function getBpSkuIdList(params) {
  return requestApi.post("/scbasic/custom/recommend/selBpList", params);
}
// 查询sku信息
export async function getSkuInfo(params) {
  return requestApi.post("sctrading/goods/sel", params);
}
